// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__Qi0NS","Icon":"Button_Icon__qzYB7","Title":"Button_Title__mF4cJ","ButtonCenter":"Button_ButtonCenter__rAw8l"};